import React from 'react';
import { PricingGrid } from './PricingGrid';

function Reveal({ children, delay = 0 }) {
  return (
    <div
      style={{
        animation: `fadeUp 0.6s ease ${delay}s both`,
      }}
    >
      {children}
    </div>
  );
}

export function PricingSection({ RevealWrapper = Reveal }) {
  return (
    <section
      id="pricing"
      className="py-24 px-4 relative overflow-hidden"
      data-testid="pricing-section"
      style={{
        background:
          'linear-gradient(180deg, hsl(220 25% 97%) 0%, hsl(220 20% 95%) 40%, hsl(220 15% 96%) 100%)',
      }}
    >
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at center top, hsla(221, 100%, 50%, 0.12) 0%, transparent 65%)',
        }}
      />
      <div className="max-w-6xl mx-auto">
        <RevealWrapper>
          <div className="text-center mb-14">
            <div className="text-xs font-mono font-medium text-primary uppercase tracking-widest mb-3">
              PRICING
            </div>
            <h2 className="text-3xl sm:text-4xl font-cabinet font-black tracking-tight mb-4">
              Transparent plans, no surprises
            </h2>
            <p className="text-lg text-muted-foreground font-plex max-w-lg mx-auto">
              One payment. Full platform access. Cancel any time.
            </p>
          </div>
        </RevealWrapper>

        <PricingGrid showCurrencySelector={false} ctaHref="/signup" />

        <RevealWrapper delay={0.3}>
          <p className="text-center text-sm text-muted-foreground mt-8 font-plex">
            All plans include our score improvement guarantee. If your score doesn't improve, we'll extend your access.
          </p>
        </RevealWrapper>
      </div>
    </section>
  );
}
